
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Crown, LogIn } from "lucide-react";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { Tabs } from "@/components/ui/tabs";
import { GalleryTabs } from "./GalleryTabs";
import { PregnancyPhotoCollection } from "./PregnancyPhotoCollection";

export function GuestGallery() {
  const { language } = useLanguage();
  
  return (
    <main className="min-h-screen pt-24 pb-16">
      <div className="container max-w-4xl mx-auto px-4">
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <h1 className="text-3xl font-bold tracking-tight mb-4">
            {t('gallery.title', language)}
          </h1>
          <p className="text-muted-foreground mb-6">
            {language === 'ja' 
              ? 'サインインして、赤ちゃんの成長を写真で記録しましょう。'
              : language === 'es'
              ? 'Inicia sesión para registrar el crecimiento de tu bebé con fotos.'
              : 'Sign in to record your baby\'s growth with photos.'}
          </p>
          <div className="flex gap-4 justify-center mb-8">
            <Link to="/login">
              <Button variant="outline" className="flex items-center gap-1">
                <LogIn className="h-4 w-4" />
                {t('common.login', language)}
              </Button>
            </Link>
            <Link to="/premium">
              <Button className="flex items-center gap-1 bg-amber-500 hover:bg-amber-600">
                <Crown className="h-4 w-4" />
                {t('index.premiumBenefits.upgradeToPremium', language)}
              </Button>
            </Link>
          </div>
        </div>
        
        {/* Display gallery demo with sample photos for guest users */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('gallery.guestDemo', language) || 'Gallery Preview'}</h2>
          <div className="mb-4 text-muted-foreground">
            <p>{t('gallery.sampleDescription', language) || 'Browse our sample gallery to see what you can create with a premium account. Upload and organize your own photos when you sign up!'}</p>
          </div>
          <GalleryTabs
            isPremium={false}
            isGuestMode={true}
            recentPhotos={[]}
            milestonePhotos={[]}
            collectionPhotos={{}}
            fetchGalleryPhotos={() => {}}
          />
        </div>
        
        {/* Sample pregnancy collection */}
        <PregnancyPhotoCollection isGuestMode={true} />
      </div>
    </main>
  );
}
